import React, { useMemo, useCallback } from 'react';
import { useSelector } from 'react-redux';
import Button from 'components/DesignSystem/Button';
import Accordion from 'components/Accordion';
import { store } from 'redux/store';
import {
  selectMeteorologyFieldsModelPerformancePeriodType,
  selectMeteorologyFieldsModelPerformanceAnalysisType,
  selectMeteorologyFieldsModelPerformanceVariable,
  selectMeteorologyFieldsModelPerformancePentad,
  selectMeteorologyFieldsModelPerformanceSelectedRounds,
  selectMeteorologyFieldsModelPerformanceAnalysisPeriod,
  selectMeteorologyFieldsModelPerformanceRounds,
  clearFilters,
} from 'redux/reducers/meteorologyFieldsModelPerformanceReducer';
import { modelPerformanceApi } from 'services/api/Meteorology/Fields/ModelPerformance';
import useMapData from 'hooks/Meteorology/Fields/ModelPerformance/useMapData';
import PeriodType from './PeriodType';
import AnalysisType from './AnalysisType';
import Variable from './Variable';
import AnalysisPeriod from './AnalysisPeriod';
import RoundsSelector from './RoundsSelector';
import Rounds from './Rounds';

export default function ModelPerformance() {
  const periodType = useSelector(selectMeteorologyFieldsModelPerformancePeriodType);
  const analysisType = useSelector(selectMeteorologyFieldsModelPerformanceAnalysisType);
  const variable = useSelector(selectMeteorologyFieldsModelPerformanceVariable);
  const pentad = useSelector(selectMeteorologyFieldsModelPerformancePentad);
  const rounds = useSelector(selectMeteorologyFieldsModelPerformanceRounds);
  const selectedRounds = useSelector(selectMeteorologyFieldsModelPerformanceSelectedRounds);
  const analysisPeriod = useSelector(selectMeteorologyFieldsModelPerformanceAnalysisPeriod);

  const { triggerMapDataRequest, isLoading } = useMapData();

  const isQueryButtonDisabled = useMemo(() => {
    if (!periodType || isLoading) return true;

    if (periodType === 'preset') {
      return !analysisType || !variable || !pentad || !rounds || rounds.length === 0;
    }

    if (periodType === 'free') {
      const hasRounds = Array.isArray(selectedRounds) && selectedRounds.length > 0;
      const hasPeriod = Boolean(
        analysisPeriod?.start && analysisPeriod?.end && analysisPeriod.start !== analysisPeriod.end,
      );
      return !analysisType || !variable || !hasRounds || !hasPeriod;
    }

    return true;
  }, [periodType, analysisType, variable, pentad, rounds,
    selectedRounds, analysisPeriod, isLoading]);

  const handleClearFilters = useCallback(() => {
    store.dispatch(clearFilters());
    // Limpar cache do RTK Query
    store.dispatch(modelPerformanceApi.util.resetApiState());
  }, []);

  const handleQuery = useCallback(() => {
    triggerMapDataRequest();
  }, [triggerMapDataRequest]);

  return (
    <div>
      <Accordion defaultActiveKey="0">
        <PeriodType />
        <AnalysisType />
        <Variable />
        <RoundsSelector />
        <AnalysisPeriod />
        <Rounds />
      </Accordion>
      <Button
        className="w-100 mt-5"
        onClick={handleQuery}
        disabled={isQueryButtonDisabled}
      >
        {isLoading ? 'Carregando...' : 'Realizar consulta'}
      </Button>
      <Button
        type="tertiary"
        className="w-100 mt-2"
        onClick={handleClearFilters}
      >
        Limpar filtros
      </Button>
    </div>
  );
}
